import { render, staticRenderFns } from "./NiceLayout.vue?vue&type=template&id=58876a21"
import script from "./NiceLayout.vue?vue&type=script&lang=js"
export * from "./NiceLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports